import styled from 'styled-components'

import { Box } from '@redriverpress/system'

// A small badge designed to show the number of items contained in a thing
export const CountBadge = styled(Box).attrs({
  display: 'inline-flex',
  alignItems: 'center',
  ml: 2,
  px: 2,
  bg: 'gray150',
  color: 'gray900',
  fontSize: '0.75rem',
  fontWeight: 600,
  flexShrink: 0,
  borderRadius: '1rem',
})``

// A version of the CountBadge to be used in ActiveTabs tabs,
// where the counter shows the number of things in that tab.
// .active class added by React Router NavLink in AdaptiveTabs.
export const TabCountBadge = styled(Box).attrs({
  display: 'inline-block',
  ml: 2,
  px: 2,
  bg: 'transparent',
  color: 'gray900',
  fontSize: '0.75rem',
  fontWeight: 600,
  border: '1px solid',
  borderColor: 'gray300',
  borderRadius: '1rem',
})`
  .active & {
    background: ${props => props.theme.colors.gray150};
    border-color: transparent;
  }
`
